import Modal from "./modal";
import { payRateTypeObj, shiftTypeObj } from "../../../helpers/data";
import { useState } from "react";
import PayRate from "../payRate";
import { formatNumberWithCommas } from "../../../helpers/regEx";

const PayRateSummary = (props) => {
  const [showModal, setShowModal] = useState(false);
  const edit = (event) => {
    event.preventDefault();
    setShowModal(!showModal);
  };
  const save = (event) => {
    event.preventDefault();
    props.sumbitJobDetails(false).then((success) => {
      if (success) {
        setShowModal(!showModal);
      }
    });
  };
  return (
    <div className="col-md-12 col-xl-12">
      <div className="card">
        {showModal && (
          <Modal label={"Pay Rate"} showHide={edit} saveFunction={save}>
            <PayRate errors={props.errors} isEditMode = {props?.editMode }/>
          </Modal>
        )}
        <div className="col-lg-12 col-md-12">
          <div className="row">
            <div className="card-header">
              <b>
                <h5 className="mb-0">Pay Rate</h5>
              </b>
              {props.editMode && (
                <a
                  className="edit-icon"
                  id="btnShowModel_Job_Type"
                  href="#"
                  onClick={edit}
                >
                  <i className="fe fe-edit" title="Edit Pay Rate"></i>
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="form-group">
            <div className="row">
              <div className="col-lg-4 col-md-4">
                <label className="form-label">Pay Rate Type : </label>
                <label htmlFor="payRateType">
                  {props?.payRateType === payRateTypeObj.systemCal
                    ? "System Payrate"
                    : props?.payRateType === payRateTypeObj.manualCal
                    ? "Fixed Payrate"
                    : ""}
                </label>
              </div>
              {props?.payRateType === payRateTypeObj.manualCal ? (
                <div className="col-lg-4 col-md-4">
                  <label htmlFor="amountPerShift" className="form-label">
                    
                    Total Shift Amount
                  </label>
                  <label htmlFor="payRateTotalShiftAmount">{props?.payRateTotalShiftAmount ? `$ ${formatNumberWithCommas(props?.payRateTotalShiftAmount)}`: props?.payRateTotalShiftAmount}</label>
                </div>
              ) : (
                ""
              )}

              {props?.payRateType === payRateTypeObj.manualCal &&
              +props?.recursionFlag === shiftTypeObj.multiShift ? (
                <div className="col-lg-4 col-md-4">
                  <label htmlFor="totalShiftAmount" className="form-label">Amount Per Shift</label>
                  <label htmlFor="payRateOccurrenceAmount">
                    {props?.payRateOccurrenceAmount ? `$ ${formatNumberWithCommas(props?.payRateOccurrenceAmount)}`: props?.payRateOccurrenceAmount}
                  </label>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayRateSummary;
